import { render } from "./Loading.vue?vue&type=template&id=abb1bd76&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=abb1bd76&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb1bd76"]])

export default __exports__